import styled from 'styled-components';

export const UserEmail = styled.p`
  padding-top: 10px;
`;
